import React from 'react';
import NotInAppNotice from "../../components/shared/NotInAppNotice";
import SafeImage from "../../components/shared/SafeImage";
import { Button } from 'reactstrap';
import ModalBox from '../../components/shared/pageComponent/ModalBox';
import DataTable from 'react-data-table-component';
import DummyIcon from '../../assets/images/user.jpg';
import { NavLink, withRouter } from 'react-router-dom';
import PodcastForm from './PodcastForm';
import {
  userList, getAwsCredentials, createPodcast,
  getPodcastList, searchUserByName,
} from '../../api/admin';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Pagination from "react-js-pagination";

class PodcastListing extends React.Component {

  constructor(props) {
    super(props);
    this.InputSwitch = React.createRef();
    this.state = {
      isModalOpen: false,
      name: '',
      user: '',
      is_show: false,
      audio_url: [],
      userLists: [],
      awsCredentials: null,
      fileData: null,
      s3_audio_key: [],
      s3_audio_duration: [],
      userId: null,
      isDisabled: true,
      urls: [],
      podcastsList: [],
      totalCounts: 0,
      limit: 10,
      activePage: 1,
      sort: false,
      sortBy: null,
      inputValue: ''
    }
  }

  getPodCastList = async (pageNumber, sortBy = this.state.sortBy, sortDir = this.state.sort) => {
    const podcastList = await this.props.getPodcastList(pageNumber ? pageNumber : 1, sortBy, sortDir);
    // The wrapper resolves `false` on failure, and `false.totalCounts` throws —
    // the list guarded the rows and not the count, so a transient error white-
    // screened the screen instead of showing an empty table.
    this.setState({
      podcastsList: (podcastList && podcastList.users) || [],
      totalCounts: (podcastList && podcastList.totalCounts) || 0,
    });
    this.props.setLoading(false);
  }

  async componentDidMount() {
    this.props.setLoading(true);
    this.props.setTitlePage('Podcast Management');
    await this.getPodCastList();
    const awsCredentials = await this.props.getAwsCredentials()
    this.setState({ awsCredentials });
    this.props.setLoading(false);
  }

  toggleModal = () => this.setState({
    isModalOpen: !this.state.isModalOpen,
    is_show: false, name: null, s3_audio_key: [],
    userId: null, user: '', inputValue: '', userLists: []
  });

  podcastMedia = (podcast) => {
    let count = 0;
    if (podcast && podcast.length) {
      podcast.forEach((element) => {
        count += element.medias.length;
      });
    }
    return count ? count : 'N/A';
  }

  columns = [
    {
      name: 'Name',
      selector: 'name',
      sortable: true,
      cell: row => <div className="user-wrapper">
        <NavLink className="link-wrap" to={`/podcast-detail/${row.id}`}>
          <SafeImage height="33" width="33" alt={row.name} src={row.ownerAvatarUrl ? row.ownerAvatarUrl : DummyIcon} />
          <span className="user-detail">
            <span className="name">{row.name}</span>
            <span className="email-wrap">{row.email}</span>
          </span>
        </NavLink>
      </div>
    },
    {
      name: 'No. of Podcast(s)',
      selector: 'podcastno',
      center: true,
      cell: row => <div className="podcast-wrapper">
        <span className="name">{row.podcasts && row.podcasts.length}</span>
      </div>
    },
    {
      name: 'No. of Audios Files',
      selector: 'audiofiles',
      center: true,
      cell: row => <div className="podcast-wrapper">
        <span className="name">{this.podcastMedia(row.podcasts)}</span>
      </div>
    },
    {
      name: 'Action',
      selector: 'action',
      center: true,
      cell: row => <NavLink className="link-wrap" to={`/podcast-detail/${row.id}`}><span className="MaroomBtn">View</span></NavLink>
    }
  ];

  handleChange = e => {
    const { value, name } = e.target;
    this.setState({ [name]: value });
    if (e.target.value === "") {
      e.target.classList.add('error');
    } else {
      e.target.classList.remove('error');
    }
  };

  handleSelect = (e, item) => {
    if (e) {
      this.setState({ user: item, userId: item.id, inputValue: item.value });
    }
  };

  searchInputChange = async (e) => {
    let inputValue = e.target.value
    this.setState({ inputValue }, async () => {
      const usersList = await this.props.searchUserByName(inputValue);
      if (usersList && usersList.data) {
        let userslist = [];
        usersList.data.length && usersList.data.forEach((user, key) => {
          userslist.push({
            value: user.name,
            id: user.id,
            label: <div className="list-with-icon" key={key}>
              <span className="img-wrap">
                <SafeImage className="small-icon" src={user.profileImageUrl ? user.profileImageUrl : DummyIcon} alt="red" height="30px" width="30px" />
              </span>
              <div className="user-info">
                <strong className="user-name">{user.name}</strong>
                <small className="email">{user.email}</small>
              </div>
            </div>
          })
        });
        this.setState({ userLists: userslist })
      }
    });

  }

  handleCustom = e => {
    this.setState({ is_show: !this.state.is_show });
  };

  createPodcast = async () => {
    const { name, userId, is_show, s3_audio_key, s3_audio_duration } = this.state;
    if (!name && !userId && s3_audio_key && !s3_audio_key.length) {
      return;
    } else if (!name) {
      toast('Please enter podcast name!', { type: 'error' });
      return;
    } else if (!userId) {
      toast('Please select a user!', { type: 'error' });
      return;
    } else if (s3_audio_key && !s3_audio_key.length) {
      toast('Please upload atleast one audio track!', { type: 'error' });
      return;
    }
    this.props.setLoading(true);
    const data = {
      "name": name,
      "user_id": userId,
      "is_show": is_show,
      "audio_url": []
    }
    if (s3_audio_key && s3_audio_key.length) {
      s3_audio_key.forEach((url, key) => {
        data.audio_url.push({
          "url": `/${url}`,
          "duration": s3_audio_duration[key],
          "thumbnail": null,
          "title": url.split('/audio/')[1]
        })
      })
    }
    const create = await this.props.createPodcast(data);
    if (create && create.status === 201) {
      toast('Podcast created successfully!');
      this.setState({
        isModalOpen: false, name: '',
        userId: null, user: '', is_show: false, s3_audio_key: [],
        inputValue: '',
        userLists: []
      });
      this.props.setLoading(true);
      this.getPodCastList();
    } else if (create && create.data) {
      toast(create.data, { type: 'error' });
    }
    this.props.setLoading(false);
  }

  getDuration = (data) => {
    let audio = document.createElement('audio');
    audio.src = data.location;
    audio.addEventListener('loadedmetadata', () => {
      var duration = audio.duration;
      this.setState({
        s3_audio_duration: [...this.state.s3_audio_duration, `${parseInt(duration)}`]
      }, () => {
        return true;
      })
    }, false);
  }

  // Podcast audio upload. This read raw IAM keys off `awsCredentials.s3`, but
  // `getAwsCredentials` is a stub returning `false` — and with no try/catch and
  // `setLoading(true)` already called, the resulting TypeError left the spinner
  // hanging forever with no error shown.
  //
  // Not rewired to the presigned flow (as the Headline/EditProfile uploads
  // were), because there is no `POST /admin/podcasts` to create the podcast
  // afterwards: uploading would only strand audio in S3. Podcasts are a
  // legacy-only feature — 0 rows in the DB, no surface in the v2 app — so this
  // says so instead of pretending to work.
  uploadAudioOns3 = async () => {
    toast("Uploading podcast audio isn't supported in the new Admin Site.", {
      type: "info",
      autoClose: 8000,
    });
    this.props.setLoading(false);
  }

  onFileChange = (file) => {
    const selectedFile = file.target.files[0];
    if (
      selectedFile.type.includes('wav') ||
      selectedFile.type.includes('mpeg') ||
      selectedFile.type.includes('mp3')
    ) {
      const date = new Date();
      Object.defineProperty(file.target.files[0], 'name', {
        writable: true,
        value: `${date.getTime()}_${file.target.files[0].name.replaceAll(' ', '')}`
      });
      this.setState({ fileData: file.target.files }, () => {
        if (!this.state.userId) {
          toast('Please select user!', { type: 'error' });
          this.setState({ fileData: null })
          return false;
        } else if (this.state.s3_audio_key && this.state.s3_audio_key.length >= 3) {
          toast('You can upload only three audio track in a podcast', { type: 'error' });
          return false;
        }
        else {
          this.uploadAudioOns3();
        }
      });
    } else {
      file.target.value = '';
      return toast('You can upload only mp3 or wav file', { type: 'error' });
    }
    return false;
  }

  removeTrack = (track) => {
    const newTrack = this.state.s3_audio_key.filter(e => e !== track);
    this.setState({ s3_audio_key: newTrack })
  }

  handlePageChange(pageNumber) {
    this.setState({ activePage: pageNumber }, () => {
      this.getPodCastList(pageNumber);
    });
    this.props.setLoading(true);
  }

  onSort = (e) => {
    this.setState({
      sort: !this.state.sort,
      sortBy: e.selector
    }, () => {
      this.getPodCastList(this.state.activePage, e.selector, this.state.sort);
    });
    this.props.setLoading(true);
  }

  render() {
    const { name, is_show, audio_url, user, userLists,
      s3_audio_key, isDisabled, userId, InputSwitch,
      podcastsList, limit, totalCounts, activePage
    } = this.state;
    return (
      <>
        <NotInAppNotice>
          The app has no podcast surface, so the “Show this podcast on app” switch has
          no effect for now.
        </NotInAppNotice>
        <div className="header-section minus-space">
          <div className="create-podcast">
            <Button color="primary" onClick={this.toggleModal}>Create Podcast</Button>
            <ModalBox
              isOpen={this.state.isModalOpen}
              ModalTitle="Create Podcast"
              withHeader={true}
              toggle={this.toggleModal}
              className="modal-right">
              <PodcastForm name={name} user={user} audio_url={audio_url}
                is_show={is_show} handleChange={this.handleChange}
                handleSelect={this.handleSelect}
                handleCustom={this.handleCustom}
                searchInputChange={this.searchInputChange}
                createPodcast={this.createPodcast}
                userLists={userLists}
                onFileChange={this.onFileChange}
                s3_audio_key={s3_audio_key}
                isDisabled={isDisabled}
                userId={userId}
                removeTrack={this.removeTrack}
                InputSwitch={InputSwitch}
                inputValue={this.state.inputValue}
              />
            </ModalBox>
          </div>
        </div>
        <DataTable
          title="Manage Podcasts"
          columns={this.columns}
          className="custom-table with-5-col"
          data={podcastsList}
          onSort={this.onSort}
        />
        {totalCounts > 0 && <Pagination
          activePage={activePage}
          itemsCountPerPage={limit}
          totalItemsCount={totalCounts}
          pageRangeDisplayed={5}
          onChange={this.handlePageChange.bind(this)}
        />}
      </>
    )
  }
}

const mapStateToProps = store => {
  return {
    admin: store.user
  }
}

export default connect(mapStateToProps, {
  userList,
  getAwsCredentials,
  createPodcast,
  getPodcastList,
  searchUserByName
})(withRouter(PodcastListing));
